<!-- Loading animation -->
<cv-loader *ngIf="showLoader"></cv-loader>

<div class="modal-header">
    <h7 cvLocalizedText langSection="Dashboard_Input" [langKey]="'Title_' + type"></h7>
    <button *ngIf="!showFolder" type="button" (click)="activeModal.close();" class="icon-btn fill-iconDefault modal-close">
        <svg class="icon-12">
            <use href="../App_Themes/CXone/icons/close.svg#close"></use>
        </svg>
    </button>
    <button *ngIf="showFolder" type="button" (click)="activeModal.close();" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
</div>
<div class="modal-body cxone-save-dashboard-body" >
        <div class="mb-3" *ngIf="type === 'FromTemplate'">
            <div class="subtitle-1 mb-2" cvLocalizedText langSection="Dashboard_Input" langKey="Selected_Template">Selected Template:</div>
            <div class="mb-2">
                <input class="form-control template-name" readonly value={{templateName}}/>
            </div>
        </div>
        <div class="mb-3">
            <div *ngIf="!isReport" class="subtitle-1 mb-2" cvLocalizedText langSection="Dashboard_Input" langKey="Name"></div>
            <div *ngIf="isReport" class="subtitle-1 mb-2" cvLocalizedText langSection="Dashboard_Input" langKey="Report_Name"></div>
            <div>
                <input #dashboardName="ngModel"
                    class="dashboardInputInput form-control form-control-lg cxoneInput"
                    ngbAutoFocus
                    [title]="requiredField"
                    name="dashboardName"
                    [(ngModel)]="data.dashboardName"
                    (ngModelChange)="characterLimit(data.dashboardName)" 
                    [ngStyle]="{ 'border-color': dashboardName.errors?.['pattern'] && data.iscxone ? '#bd2026' : '' }"
                    [required]="true" maxlength="50" type="text"
                    [pattern]="invalidCharsRegex"
                    cvLocalizedPlaceholder langSection="Dashboard_Input" langKey="Required" />
                    <div class="character-limit" [hidden]="dashboardName.errors?.['pattern']">
                        <span>{{ getTextLimitMessage() }} </span>
                    </div>
                <div [hidden]="!dashboardName.errors?.['required'] || data.iscxone" class="ml-1 color-redRyder" cvLocalizedText langSection="Dashboard_Input" langKey="Required"></div>
            </div>
            <div [hidden]="!dashboardName.errors?.['pattern'] || !data.iscxone" class="ml-1 color-redRyder" cvLocalizedText langSection="Dashboard_Input" langKey="PatternError"></div>
        </div>
        <div class="mb-3" *ngIf="showFolder">
            <div class="subtitle-1 mb-2" cvLocalizedText langSection="Dashboard_Input" langKey="FolderLocation"></div>
            <div class="d-inline-flex">
                <input class="form-control" list="save-dashboard-folders" [(ngModel)]="data.folder" max-length="50" />
                <datalist id="save-dashboard-folders">
                    <option *ngFor="let folder of dashboardService.dashboardGroups" [value]="folder">
                </datalist>
                <div [hidden]="!isStringEmpty(data.folder)" class="ml-1 color-redRyder" cvLocalizedText langSection="Dashboard_Input" langKey="Required"></div>
            </div>
        </div>
        <div class="mb-3">
            <div class="subtitle-1 mb-2" cvLocalizedText langSection="Dashboard_Input" langKey="Description"></div>
            <div>
                <textarea #description="ngModel"
                    [(ngModel)]="data.description" 
                    [ngStyle]="{ 'border-color': description.errors?.['pattern'] && data.iscxone ? '#bd2026' : '' }"
                    [maxlength]="data.iscxone ? 255 : 1024" rows="7" style="resize: none; padding: 0.5rem;" 
                    class="dashboardInputInput form-control form-control-lg cxoneInput" type="text" 
                    name="description"
                    [pattern]="invalidDescriptionCharsRegex"
                    cvLocalizedPlaceholder langSection="Dashboard_Input" langKey="Description_PHD"></textarea>
            </div>
            <div [hidden]="!description.errors?.['pattern'] || !data.iscxone" class="ml-1 color-redRyder" cvLocalizedText langSection="Dashboard_Input" langKey="PatternError"></div>
        </div>
</div>

<div class="modal-footer">
    <button type="button" [ngClass]="{'modal-footer-btn btn-secondary': isCXOne, 'cancelButton, footerButton, mr-2': !isCXOne}" class="btn" (click)="activeModal.close();" 
    cvLocalizedText langSection="Users" langKey="Cancel_Button">Cancel</button>
    <button type="button" [ngClass]="{'modal-footer-btn cxone-btn': isCXOne, 'cancelButton, footerButton': !isCXOne}" class="btn btn-primary" *ngIf="type !== 'NewDashboard' && type !== 'CopyDashboard'"
    [disabled]="dashboardName.invalid || description.invalid || isStringEmpty(dashboardName.value) || isStringEmpty(data.folder) || isSaving" (click)="save()">
        <span cvLocalizedText langSection="Users" langKey="Save_Button">Save</span>
    </button>
    <button type="button" [ngClass]="{'modal-footer-btn cxone-btn': isCXOne, 'footerButton': !isCXOne}" class="btn btn-primary" *ngIf="type === 'NewDashboard' || type === 'CopyDashboard'"
    [disabled]="dashboardName.invalid || description.invalid  || isStringEmpty(dashboardName.value) || isStringEmpty(data.folder) || isSaving" (click)="save()">
        <span cvLocalizedText langSection="Users" langKey="Create_Button">Create</span>
    </button>
</div>
